import React from 'react';
import connect from 'Shared/connect';
import { TINY } from 'Shared/breakpoints';
import * as styles from './base.scss';
const ProductCardListHeader = ({ currentBreakpoint }) => currentBreakpoint > TINY && (React.createElement("div", { className: styles.header },
    React.createElement("div", { className: styles.headerInner })));
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
}))(ProductCardListHeader);
